import * as Yup from 'yup';
import { Product } from '../../../../../../shared/types/systemConfiguration/products';

export const initialValues: Product = {
    name: '',
    code: '',
    description: '',
    active: true,
    applyEscalations: true,
    applyPqr: true,
    sfcCaptureUnit: '',
    sfcCaptureUnitNew: '',
};

export const validationSchema = () =>
    Yup.object({
        name: Yup.string().required('El nombre es obligatorio'),
        code: Yup.string().required('El Código es obligatorio'),
    });
